<div class="override-conflict-dialog">
  <span class="override-conflict-dialog__title" *ngIf="isSaveConflict" i18n="@@S_LIVEMAP_OVERRIDE_SAVE_CONFLICT_TITLE"
    >Unable to update this road</span
  >
  <span class="override-conflict-dialog__title" *ngIf="!isSaveConflict" i18n="@@S_LIVEMAP_OVERRIDE_SELECT_CONFLICT_TITLE"
    >Unable to select this road</span
  >
  <span class="override-conflict-dialog__description" i18n="@@S_LIVEMAP_OVERRIDE_CONFLICT_DESCRIPTION">
    You cannot update the posted speed on this section of road as it has already been updated.
  </span>
  <span class="override-conflict-dialog__description" i18n="@@S_LIVEMAP_OVERRIDE_CONFLICT_ACTION_HINT">
    You can either update the existing edit for this section of the road, or delete it.
  </span>
  <div class="override-conflict-dialog__buttons">
    <button mat-raised-button color="tertiary" class="btn-uppercase" i18n="@@S_CANCEL" (click)="onCancel()">CANCEL</button>
    <button mat-flat-button color="accent" class="btn-uppercase" i18n="@@S_LIVEMAP_OVERRIDE_CONFLICT_VIEW_UPDATE" (click)="onViewUpdate()">
      VIEW UPDATE
    </button>
  </div>
</div>
